module.exports = __webpack_public_path__ + "media/images/screens/06_listeProduits_compare-18ed9f8b9ba83614e914d2cf5890b085.jpg";